import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
var Channels = function () {
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", children: "Channels" }), _jsx(Typography, { children: "Manage OTA connections and channel mappings" })] }));
};
export default Channels;
